module.exports = __webpack_public_path__ + "static/WEDDING E&M-148-b61211d710f22fd5a5c045ebb0b336f4.jpg";